/**
 * WebGLChart Constants
 */

export const LOCALE = "de-DE";
export const CHART_HEIGHT = 400;

// WebGL specific constants
export const ZOOM_FACTOR = 0.85; // Smoother zoom steps
export const MAX_ZOOM = 100000; // Allow extreme zoom for finest detail viewing
export const MIN_ZOOM = 1;
export const DRAG_THRESHOLD = 0; // pixels - allow any size rectangular selection

// Chart padding for axis labels (must match AxisOverlay)
export const CHART_PADDING = {
  left: 60,  // Increased to accommodate Y-axis label without overlap
  right: 15,
  top: 15,
  bottom: 45,
};
